import React, { useState, useContext, useEffect } from 'react';
import ApplicationContext from '../components/ApplicationContext';
import {postDataWithFetch, setLocalStorage} from '../components/Utils';

function LoginPage({ setData }) {
    const data = useContext(ApplicationContext);

    const [userName, setUserName] = useState("");
    const [password, setPassword] = useState("");

    const [formData, setFormData] = useState({
        username: '',
        password: ''
    });

    const handleChange = (e) => {
        // console.log('DEBUG:', "Entering handleChange");
        // console.log('DEBUG:', `e.target.name = ${e.target.name}`);
        switch (e.target.name) {
            case "username":
                setUserName(e.target.value)
                break;
            case "password":
                setPassword(e.target.value)
                break;
            default:
                break;
        }
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const [clickedSubmit, setClickedSubmit] = useState(false);
    const handleSubmit = (e) => {
        e.preventDefault();
        setClickedSubmit(true);
    };
    useEffect(() => {
        if (clickedSubmit) {
            ((async() => {
                // console.log('DEBUG:', "Entering clickedSubmit useEffect");
                const url = `${data.BASE_URL}index.php/user/login`;
                const params = { USERNAME: userName, PASSWORD: password };
                // console.log('DEBUG:', `url = ${url}`);
                // console.log('DEBUG:', `formData = ${JSON.stringify(params)}`);
                const json = await postDataWithFetch(url, params);
                // console.log(json);

                if (json?.status) {
                    setLocalStorage('token', json.token);
                    setLocalStorage('username', json.user.username);
                    setLocalStorage('is_premium', json.user.is_premium);
                    if (data.enableAdmin) {
                        setLocalStorage('currentPage', 'admin');
                        data.currentPage = 'admin';
                        setData((prev) => ({ ...prev, currentPage: 'admin' }));
                    }
                    else {
                        setLocalStorage('currentPage', 'home');
                        data.currentPage = 'home';
                        setData((prev) => ({ ...prev, currentPage: 'home' }));
                    }
                    setIsError(false);
                    // console.log("DEBUG", "Successful login");
                }
                else {
                    setIsError(true);
                    // console.log("DEBUG", "Failed login");
                }
                setClickedSubmit(false);
            })());
        }
    }, [data, data.BASE_URL, password, userName, clickedSubmit, setData]);

    const [isError, setIsError] = useState(false);

    return (
        <>
            <div className="login">
                <h1>Login</h1>
                <form method="post" onSubmit={handleSubmit} >
                    <input type="text" name="username" onChange={(e) => handleChange(e)} value={userName} placeholder="Username" required />
                    <input type="password" name="password" onChange={(e) => handleChange(e)} value={password} placeholder="Password" required />
                    <p className="submit">
                        <input type="submit" value="Login" />
                    </p>
                    <div className="login-error" style={{display: isError ? "block" : "none"}}>
                        Userid and/or password has not been entered correctly, please check your log in 
                        cretentials and try again.
                    </div>
                </form>
            </div>
        </>
    );
}

export default LoginPage;
